export default function productAmount(){
    if(document.querySelector("#amount")){
        let inputNumber = document.querySelector("#amount");
        let increaseButton = document.querySelector(".increase");
        let decreaseButton = document.querySelector(".decrease");

        increaseButton.addEventListener("click", () => {
            inputNumber.value = parseInt(inputNumber.value) + 1;
        });

        decreaseButton.addEventListener("click", () => {
            inputNumber.value = parseInt(inputNumber.value) - 1;
        });
    }
}